import React, { Fragment, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Grid2,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import "@fontsource/open-sans";
import "@fontsource/inter";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import { ErrorToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";



const Grid = (props) => <Grid2 {...props} />;

function Dashboard() {
  const [analytics, setAnalytics] = useState({});
  const navigate  = useNavigate()
 

  const line1Cards = [
    {
      name: "Live Trains",
      number: analytics?.TrainCount,
      path:"/live-trains"
    },
    {
      name: "Registered Stations",
      number: analytics?.StationCount,
      
    },
    {
      name: "Live Speed Check ",
    },
  ];

  const getAnalytics = async () => {
    try {
      const result = await AuthServices.getDashboard();
      if (result.IsSuccess == true) {
        setAnalytics(result.Response);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
 
 
  useEffect(() => {
    getAnalytics();
    
  }, []);



  return (
    <Fragment>
      <Grid container rowGap={3}>
        <Grid size={12}>
          <Typography
            sx={{
              fontSize: "1.51rem",
              fontWeight: 500,
              fontFamily: "Open Sans",
              color: Colors.primary,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
           Dashboard
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box
            sx={{
              height: "calc(100vh - 237px)",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Grid container rowGap={3}>
              <Grid size={12}>
                <Grid container spacing={2}>
                  {line1Cards.map((item, ind) => (
                    <Grid key={ind} size={{ xs: 12, sm: 6, md: 4 }}>
                      <Box
                        sx={{
                          p: 3,
                          display: "flex",
                          flexDirection: "column",
                          boxShadow: "0px 8px 24px 0 #4545501A",
                          backgroundColor: Colors.white,
                          height:'200px',
                          justifyContent:"center",
                          borderRadius:"12px",
                          cursor:"pointer"
                        }}
                        onClick={()=>navigate(item?.path)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            margin: " 0 auto",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Open Sans",
                              fontSize: "23px",
                              fontWeight:"bold",
                              color: "#404e67",
                              textAlign:"center"
                            }}
                          >
                            {item.name}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            margin: " 0 auto",
                            textAlign:"center"

                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "28px",
                              fontWeight: 500,
                              fontFamily: "Open Sans",
                              lineHeight: "40px",
                              color: "#404e67",
                            }}
                          >
                            {item.number}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
             
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Dashboard;
